import http from 'hub-http/clients/apiClient';
const RECORD_PROPERTY_CLICKED_EVENT_URL = 'api/chirp-frontend-app/v1/gateway/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService/recordPropertyClickedEvent';
export const recordPropertyClickedEvent = ({
  searchString,
  filterFamily,
  options,
  selectedOption
}) => {
  if (!selectedOption) {
    return;
  }
  const clickedResult = {
    propertyName: selectedOption.name,
    objectTypeId: filterFamily
  };
  const servedResponseResults = options === null || options === void 0 ? void 0 : options.map(option => ({
    objectTypeId: filterFamily,
    propertyName: option.name
  }));

  // Fire and forget
  http.post(RECORD_PROPERTY_CLICKED_EVENT_URL, {
    data: {
      input: searchString,
      clickedResult,
      servedResponseResults
    }
  }).catch(error => {
    console.error('Error recording property clicked event', error);
  });
};